
(() => {
  const SECTION_SELECTOR = '[id^="MainProduct-"]';
  const CONTAINER_SELECTOR = '[data-zento-isometria]';
  const JSON_SELECTOR = '[data-zento-variant-isometrias]';
  const PICKER_SELECTOR = 'variant-radios, variant-selects';

  const pendingUpdates = new WeakMap();
  let lastUrl = window.location.href;

  function getVariantId(section) {
    const urlVariant = new URLSearchParams(
      window.location.search
    ).get('variant');

    if (urlVariant) return urlVariant;

    const form = section.querySelector(
      'form[data-type="add-to-cart-form"]'
    );

    return form?.querySelector('input[name="id"]')?.value || null;
  }

  function updateIsometria(section) {
    const container = section.querySelector(CONTAINER_SELECTOR);
    const jsonElement = section.querySelector(JSON_SELECTOR);

    if (!container || !jsonElement) return;

    const variantId = getVariantId(section);
    if (!variantId) return;

    // No volver a renderizar si la variante no cambió.
    if (container.dataset.variantId === variantId) return;

    let isometrias;

    try {
      isometrias = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error('[Zento] JSON de isometrías inválido:', error);
      return;
    }

    const imageUrl = isometrias[String(variantId)];

    console.log('[Zento] Variante detectada:', variantId);

    if (!imageUrl) {
      container.replaceChildren();
      container.dataset.variantId = variantId;
      container.hidden = true;
      return;
    }

    const img = document.createElement('img');
    img.className = 'zento-product-isometria__image';
    img.alt = 'Isometría del producto';
    img.loading = 'lazy';
    img.src = imageUrl.startsWith('//')
      ? `${window.location.protocol}${imageUrl}`
      : imageUrl;

    img.onerror = () => {
      console.error('[Zento] No se pudo cargar la isometría:', img.src);
    };

    container.replaceChildren(img);
    container.dataset.variantId = variantId;
    container.hidden = false;
  }

  function syncAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(updateIsometria);
  }

  function scheduleSync(section) {
    if (!section) {
      syncAll();
      return;
    }

    const previous = pendingUpdates.get(section);
    if (previous) window.clearTimeout(previous);

    const timeout = window.setTimeout(() => {
      updateIsometria(section);
      pendingUpdates.delete(section);
    }, 100);

    pendingUpdates.set(section, timeout);
  }

  // Cambios en los selectores de variantes.
  document.addEventListener('change', event => {
    if (!event.target.closest?.(PICKER_SELECTOR)) return;

    scheduleSync(event.target.closest(SECTION_SELECTOR));
  });

  document.addEventListener('input', event => {
    if (!event.target.closest?.(PICKER_SELECTOR)) return;

    scheduleSync(event.target.closest(SECTION_SELECTOR));
  });

  // Cambios de URL al seleccionar variantes.
  // Cubre los métodos history usados por muchos temas Shopify.
  function checkUrlChange() {
    if (window.location.href === lastUrl) return;

    lastUrl = window.location.href;
    syncAll();
  }

  const originalPushState = history.pushState;
  history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    checkUrlChange();
    return result;
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    const result = originalReplaceState.apply(this, args);
    checkUrlChange();
    return result;
  };

  window.addEventListener('popstate', () => {
    lastUrl = window.location.href;
    syncAll();
  });

  // Detecta actualizaciones del input de variante del formulario.
  const observer = new MutationObserver(mutations => {
    const relevantChange = mutations.some(mutation => {
      const target = mutation.target;

      return (
        target.closest?.(SECTION_SELECTOR) &&
        (
          target.matches?.('input[name="id"]') ||
          target.closest?.(PICKER_SELECTOR) ||
          [...mutation.addedNodes].some(node =>
            node.nodeType === Node.ELEMENT_NODE &&
            (
              node.matches?.(PICKER_SELECTOR) ||
              node.querySelector?.(PICKER_SELECTOR)
            )
          )
        )
      );
    });

    if (relevantChange) syncAll();
  });

  function init() {
    syncAll();

    document.querySelectorAll(SECTION_SELECTOR).forEach(section => {
      observer.observe(section, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['value', 'checked']
      });
    });
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
